<template>
  <div class="resource-categories">
    <ul class="resource-ul">
      <li v-if="StyleDataMsg && StyleDataMsg.name">
        <el-tooltip
          effect="dark"
          placement="bottom"
          :open-delay="1000"
          :value="showStyleTip"
        >
          <div slot="content">
            <img src="../../../static/img/stylehand.png" class="style-tip-img" />
            &nbsp;&nbsp;&nbsp;点击这里&nbsp;&nbsp;切换风格
          </div>
          <div
            class="the-box"
            :class="{
              'bottom-right-radius': getChoosedResourceType.key === 'scene',
            }"
          >
            <div class="resource-style" @click="changeStyle">
              <img
                v-if="StyleDataMsg.iconUrl"
                :src="$handleAssetsUrl(StyleDataMsg.iconUrl)"
              />
              <div class="shelter" v-if="StyleDataMsg.name">
                <div>{{ StyleDataMsg.name.substring(0, 2) }}</div>
                <div>{{ StyleDataMsg.name.substring(2, 4) }}</div>
              </div>
            </div>
          </div>
        </el-tooltip>
      </li>
            <!-- <helpPane></helpPane> -->

      <li
        class="the-type"
        v-for="(item, index) in getResourceTypes"
        :class="{
          disabled: totals[item.key] === 0,
          active: getChoosedResourceType.content === item.content,
          'top-right-radius':
            getPaneStatus === 'pane-enter' &&
            index - 1 === getChoosedResourceType.index,
          'bottom-right-radius':
            getPaneStatus === 'pane-enter' &&
            index + 1 === getChoosedResourceType.index,
        }"
        :key="item.key"
        @click="changeType(item)"
      >
        <template v-if="item.key !== 'template' && item.key !== 'word'">
          <i class="iconfont" :class="[item.icon, item.key, {disabled: isDisabled(item)}]"></i>
        </template>
        <template v-else>
          <div :class="[item.key, {disabled: isDisabled(item)}]" :style="{'background-image': `url(${item.svgUrl})`}"></div>
        </template>

        <span class="name">
          {{ item.name }}
        </span>
        <div class="badge" :class="{disabled: totals[item.key] === 0}" v-show="isSearchAll && totalDict.total >= 0" :data-total="totalDict.total">
          {{ totals[item.key] }}
        </div>
      </li>
      <li v-if="false">
        <div class="help the-type" :class="{'top-right-radius': getChoosedResourceType.key === 'mine'}">
          <i class="iconfont iconbangzhu"></i>
          <span>帮助</span>
          <helpPane></helpPane>
        </div>
      </li>
    </ul>
    <div
      v-if="entryGuideShown"
      class="mask"
    ></div>
    <helpCenterEntry></helpCenterEntry>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import Analysis from "../mixins/analysis/materialBu";
import HelpPane from "../rightnav/controls/helpPane.vue";
import helpCenter from './helpCenter/helpCenter.vue';
import helpCenterEntry from './helpCenter/helpCenterEntry.vue';
export default {
  name: 'resourceCategories',
  data () {
    return {
      showStyleTip: false,
    };
  },
  mixins: [Analysis],
  computed: {
    ...mapGetters([
      "TopNav_Size",
      "StyleDataMsg",
      'StyleArrayMsg'
    ]),
    ...mapGetters({
      getChoosedResourceType: 'materialArea/getChoosedResourceType',
      totalDict: 'resources/totalDict',
      getPaneStatus: "materialArea/getPaneStatus",
      isSearchAll: 'resources/isSearchAll',
      getResourceTypes: 'materialArea/getResourceTypes',
      SpriteOperation: 'SpriteOperation',
      entryGuideShown: 'helpCenter/entryGuideShown',
      helpCenterShown: 'helpCenter/popoverShown'
    }),
    totals () {
      let val = this.totalDict;
      let limit = (n) => {
        return n > 999 ? '999+' : n
      }
      return {
        scene: limit(val.sceneTotal),
        template: limit(val.templateTotal),
        bg: limit(val.bgTotal),
        word: limit(val.textTotal),
        role: limit(val.characterTotal),
        visual: limit(val.materialTotal),
        music: limit(val.musicTotal),
        mine: this.isSearchAll ? 0 : void 0
      }
    }
  },
  components: {
    HelpPane,
    helpCenter,
    helpCenterEntry
  },
  created () {
    this.$bus.on('globalSearch.getTotalDict', this.onGetTotalDict);
    this.$bus.on("materialPane_vue", this.onMaterialPane);
    this.updateStyles();
  },
  beforeDestroy () {
    this.$bus.off('globalSearch.getTotalDict', this.onGetTotalDict);
    this.$bus.off("materialPane_vue", this.onMaterialPane);
  },
  methods: {
    ...mapMutations({
      setChoosedResourceType: 'materialArea/setChoosedResourceType',
      setSceneLibStatus: "materialArea/setSceneLibStatus"
    }),
    ...mapActions({
      searchAll: 'resources/searchAll',
    }),
    updateStyles () {
      this.$http.get('/api/home/style').then((res) => { // 请求风格数据
        const styleDatas = []
        let data = res.data.data;
        for(let item in data){
          let itemData = {
            id           : data[item].id,
            name         : data[item].name,
            overview     : data[item].overview ? data[item].overview.split(",") : [],
            thumbnailUrl : data[item].thumbnailUrl,
            iconUrl      : data[item].iconUrl ? data[item].iconUrl.split(",")[1] : '',
            judge        : false,
            data         : data[item],
          }
          styleDatas.push(itemData);
          itemData = null;
        }
        this.$store.commit('toggle_StyleArrayMsg', { // 切换style详细数据
          styleArray : styleDatas,
        });
        this.$store.commit('toggle_StyleDataMsg', { // 切换style详细数据
          id : 78,
        });
      })
    },
    isDisabled (item) {
      return this.totals[item.key] === 0 || item.shelter || this.isDisabledWhenSwapping(item);
    },
    isDisabledWhenSwapping (item) {
      let keysDisabled = ['scene', 'template', 'bg', 'music'];
      return this.SpriteOperation === 'swap' && keysDisabled.includes(item.key);
    },
    changeType (item) {
      if (item.shelter || this.isDisabledWhenSwapping(item)) {
        return;
      }
      if (!this.isSearchAll) {
        return this.setChoosedResourceType(item);
      }
      let map = this.getTypeMap();
      let type = map[item.key];
      if (this.totalDict[type] > 0) {
        this.setChoosedResourceType(item);
        if (item.key === 'scene') {
          this.setSceneLibStatus('pack-enter');
        }
      }
    },
    changeStyle () {
      this.materialPushAnalysis({
        type: "selectStyle"
      });
      this.$bus.emit("stop_listen_BGM");
      this.$bus.emit("Modal_vue", { name: "style" });
      // 弹出气泡提示
      this.$bus.emit("showTips", {
        text: "选择一个风格后，场景页、背景、道具、形状均会切换至相应的风格。",
        position: {
          top: `${this.TopNav_Size.height + 10}px`,
          left: "72px"
        }
      });
    },
    getTypeMap () {
      return {
        scene: 'scene',
        template: 'template',
        bg: 'background',
        word: 'text',
        role: 'character',
        visual: 'material',
        music: 'sound',
      }
    },
    async onGetTotalDict (ev) {
      let map = this.getTypeMap();
      let arr = ['scene', 'template', 'background', 'text', 'character', 'material', 'sound'];
      let data = await this.searchAll(ev);
      let type = map[this.getChoosedResourceType.key];
      let totoalDict = data.data;
      if (!totoalDict[type]) {
        let start = arr.indexOf(type);
        for (let i = start + 1; i < arr.length * 2; i++) {
          let j = i % arr.length;
          let typeTotal = totoalDict[arr[j]];
          if (typeTotal > 0) {
            this.setChoosedResourceType(this.getResourceTypes[j]);
            break;
          }
        }
      }
    },
    onMaterialPane(info) {
      if (!info.type) return;
      const getResourceTypes = this.getResourceTypes;
      if (info.type === 'scenes') {
        this.setChoosedResourceType(getResourceTypes.find(v => v.key === 'scene'));
      }
      else if (info.type === 'template') {
        this.setChoosedResourceType(getResourceTypes.find(v => v.key === 'template'));
      }
      else if (info.type === 'text') {
        this.setChoosedResourceType(getResourceTypes.find(v => v.key === 'word'));
      }
      else if (info.type === 'characters') {
        this.setChoosedResourceType(getResourceTypes.find(v => v.key === 'role'));
      }
      else if (info.type === 'personal') {
        this.setChoosedResourceType(getResourceTypes.find(v => v.key === 'mine'));
      } else {
        this.setChoosedResourceType(getResourceTypes.find(v => v.key === 'visual'));
      }
    },
    popoverConfirm () {
      this.$store.commit('helpCenter/setEntryGuideShown', false);
    },
    onClickHelpCenterEntry () {
      this.$store.commit('helpCenter/setPopoverShown', true);
    }
  }
};
</script>
<style lang="scss" scoped>
.resource-categories {
  position: relative;
  width: 72px;
  height: 100%;
  box-sizing: border-box;
  background-color: #e7e8f1;
  padding-top: 10px;
  z-index: 20;
  .style-tip-img {
    vertical-align: baseline-middle;
  }
  .resource-style {
    width: 60px;
    height: 50px;
    margin: 0 auto;
    overflow: hidden;
    border-radius: 4px;
    position: relative;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
    .shelter {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 5;
      background-color: rgba(0, 0, 0, 0.4);
      text-align: center;
      font-size: 12px;
      line-height: 18px;
      font-weight: bold;
      color: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }
  .help {
    position: relative;
    font-size: 12px;
    i {
      font-size: 20px;
    }
    &:hover {
      .helpPane {
        display: block;
      }
    }
    .helpPane {
      position: absolute;
      left: 72px;
      bottom: -25px;
      z-index: 11;
      display: none;
    }
  }

  .resource-ul {
    width: 100%;
    background-color: #fff;
    position: relative;
  }
  .top-right-radius {
    border-radius: 0 10px 0 0;
  }
  .bottom-right-radius {
    border-radius: 0 0 10px 0;
  }
  .the-box {
    background-color: #e7e8f1;
    padding-bottom: 14px;
  }
  .the-type {
    width: 72px;
    height: 70px;
    position: relative;
    background-color: #e7e8f1;
    color: #474261;
    text-align: center;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &.active {
      background-color: #fff;
    }
    .template,.word {
      margin-bottom: 6px;
      background-size: 100%;
      &.disabled {
        opacity: .5;
      }
    }
    .template {
      width: 16px;
      height: 16px;
    }
    .word {
      width: 18px;
      height: 15px;
    }
    .iconfont {
      margin-bottom: 5px;
      &.scene {
        font-size: 18px;
      }
      &.bg {
        font-size: 16px;
      }
      &.visual {
        font-size: 19px;
      }
      &.role,
      &.mine,
      &.music {
        font-size: 17px;
      }
      &.props {
        font-size: 20px;
      }
      &.disabled {
        color: #9a98ab;
      }
    }
    .name {
      font-size: 12px;
      line-height: 16px;
    }
  }

  .badge {
    position: absolute;
    left: 50%;
    top: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    height: 20px;
    padding-left: 5px;
    padding-right: 5px;
    border-radius: 360px;
    min-width: 28px;
    height: 20px;
    background-color: #f55c5c;
    &.disabled {
      background-color: #c5c5c5;
    }
  }
  .shelter {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 20;
    background-color: rgba(255, 255, 255, 0.8);
  }

  .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.6);
  }
  .help-center-entry {
    position: absolute;
    bottom: 30px;
    left: calc(50% - 18px);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 48px;
    background-color: #fff;
    cursor: pointer;

    & > span:first-child {
      font-size: 20px;
      font-weight: bold;
    }

    .guide-popover {
      position: absolute;
      left: calc(100% + 14px);
      bottom: -18px;
      width: 290px;
      height: 144px;
      background:
        url(../../assets/vipTrialMessage/bg-guide-popover.png) right top/218px 123px no-repeat,
        linear-gradient(180deg, #FFEBFC 0%, #EFF4FF 35%, #FFFFFF 100%)
        ;
      box-shadow: 0px 4px 8px rgba(0,0,0,0.1600);
      opacity: 1;
      border-radius: 4px;
      cursor: default;
      font-size: 14px;
      font-weight: 400;
      cursor: default;
      .text {
        font-weight: 800;
        padding-top: 33px;
        padding-bottom: 33px;
      }
      .button-row {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 126px;
        height: 38px;
        background: #5778FB;
        opacity: 1;
        border-radius: 4px;
        color: #fff;
        &:hover {
          background-color: #7d95f5;
          cursor: pointer;
        }
      }
    }
    .arrow-box:after {
      right: 100%;
      bottom: 24px;
      border: solid transparent;
      content: "";
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
      border-color: rgba(136, 183, 213, 0);
      border-right-color: #fff;
      border-width: 12px;
    }

    .help-center-popover {
      position: absolute;
      left: calc(100% + 6px);
      bottom: 0;
      width: 244px;
      min-height: 368px;
      background: #FFFFFF;
      box-shadow: 0px 0px 4px rgba(5,30,109,0.1200);
      opacity: 1;
      border-radius: 4px;
      cursor: default;
    }
  }
}

@media screen and (max-width: 1367px){
  .resource-categories {
    .the-box {
      padding-bottom: 10px;
      .resource-style {
        height: 42px;
      }
    }
    .the-type {
      height: 62px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/resourcesArea/resourceCategories.vue